import { render, staticRenderFns } from "./JobSearch.vue?vue&type=template&id=35795962&"
import script from "./JobSearch.vue?vue&type=script&lang=ts&"
export * from "./JobSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchInput: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/global/SearchInput.vue').default,ButtonPrimary: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/buttons/ButtonPrimary.vue').default,JobFilters: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/jobs/filters/JobFilters.vue').default})
